import { put, takeEvery, delay } from 'redux-saga/effects';
import { hideNotification } from './actions';
import { NOTIFICATION_ADD } from './constants';

function *handleNotification (action) {
  const id = action.id;
  const wait = typeof action.delay === 'number' ? action.delay : 60;
  yield delay(wait * 1000);
  yield put(hideNotification(id));
};

function *notificationSagas () {
  yield takeEvery(NOTIFICATION_ADD, handleNotification);
}

export default notificationSagas;
